/* eslint-disable no-console */
/* eslint-disable react/prop-types */
/* eslint-disable func-names */
import React, { useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { makeStyles } from '@mui/styles';
import { Typography, Toolbar, AppBar, IconButton, Popover } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HelpIcon from '@mui/icons-material/Help';
import Logout from '../Shared/Logout';
import ChangesSwitch from './ChangesSwitch';
import HelpTextBox from './HelpTextBox';
import {
  showSwitchAtom,
  slideShowAtom,
  readOnlyAtom,
  mobileAtom,
  openConfirmExitAtom,
  openProjectNameAtom,
  enableChangesAtom,
} from '../Atoms';

const useStyles = makeStyles({
  tools: {
    paddingRight: '16px',
    paddingLeft: '16px',
  },
});

const Navbar = function ({ title, show, setUser, setSidebar }) {
  const classes = useStyles();
  const slideShow = useRecoilValue(slideShowAtom);
  const readOnly = useRecoilValue(readOnlyAtom);
  const showSwitch = useRecoilValue(showSwitchAtom);
  const setConfirmExit = useSetRecoilState(openConfirmExitAtom);
  const setOpenProjectName = useSetRecoilState(openProjectNameAtom);
  const mobile = useRecoilValue(mobileAtom);
  const [help, setHelp] = useState(null);
  const enableChanges = useRecoilValue(enableChangesAtom);

  const openHelp = (event) => {
    setHelp(event.currentTarget);
  };
  const closeHelp = () => {
    setHelp(null);
  };
  const open = Boolean(help);
  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: '#00796b' }}>
      <Toolbar className={classes.tools}>
        {show && !slideShow && !mobile && (
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={() => {
              if (enableChanges) setConfirmExit(true);
              else setOpenProjectName(null);
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        {mobile && (
          <IconButton size="large" color="inherit" onClick={setSidebar}>
            <MenuIcon />
          </IconButton>
        )}
        <Typography variant="h5" component="div" sx={{ flexGrow: 1 }}>
          {!mobile && title}
        </Typography>
        {!slideShow && showSwitch && show && !mobile && !readOnly && <ChangesSwitch />}
        {show && !slideShow && (
          <div className={classes.tools}>
            <IconButton size="small" color="inherit" sx={{ ml: 2 }} onClick={openHelp}>
              <HelpIcon />
            </IconButton>
            <Popover
              open={open}
              anchorEl={help}
              onClose={closeHelp}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <HelpTextBox />
            </Popover>
          </div>
        )}
        {!slideShow && (
          <div className={classes.tools}>
            <Logout setUser={setUser} />
          </div>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
